import repository from './repsitory'

const resource = '/devices'

export default {
    get () {
        return repository.get(`${resource}`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    add (data) {
        return repository.post(`${resource}`, data)
    },
    update (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
}
